/* eslint-disable max-len */
import { useMutation } from '@apollo/client';
import React, { useState } from 'react';
import AdminModal from '../../../../components/AdminModal';
import useToast from '../../../../customHooks/useToast';
import { MODIFY_STATUS_OF_BULK_ROLES } from '../../../../graphql/admin_mutations';
import CircleCheckIcon from '../../../../svgs/CircleCheckIcon';
import RoundMinusIcon from '../../../../svgs/RoundMinusIcon';
import Styles from './ActivateAndDeactivateBulkRoles.module.scss';

interface IActivateAndDeactivateBulkRoles{
  onClose:any;
  setSelectedActivatedRoles:any;
  setSelectedDeactivatedRoles:any;
  selectedActivatedRoles:any;
  selectedDeactivatedRoles:any;
  refetch:any;
  isSelectLoader:string;
}
const ActivateAndDeactivateBulkRoles = ({
  onClose, setSelectedActivatedRoles, setSelectedDeactivatedRoles, selectedActivatedRoles, selectedDeactivatedRoles, refetch, isSelectLoader,
}:IActivateAndDeactivateBulkRoles) => {
  const Toast = useToast();
  const [modifyMutipleRolesStatus, { loading: modifyMutipleRolesStatusLoading }] = useMutation<
  { modifyStatusOfBulkRoles: any },
  any
  >(MODIFY_STATUS_OF_BULK_ROLES);

  const [isSuccessful, setIsSuccessful] = useState(false);

  const [updateRoleNames, setUpdatedroleNames] = useState(null);

  const getSelectedRoles = (data:any) => {
    const roleNames = data.map((role:any) => role?.name);

    const lastRoles = roleNames?.slice(-2);

    const otherRoleNames = roleNames.slice(0, -2).join(', ');

    const result = otherRoleNames + (otherRoleNames ? ', ' : '') + lastRoles.join(' & ');

    setUpdatedroleNames(result);
  };

  const activateAndDeactivateMutipleRoles = async (type:string, selectedData:any) => {
    const data = {
      roleIds: selectedData?.map((data:any) => data?.id),
      action: type,
    };

    if (!modifyMutipleRolesStatusLoading) {
      try {
        const res = await modifyMutipleRolesStatus({
          variables: data,
        });

        if (res?.data?.modifyStatusOfBulkRoles && res?.data?.modifyStatusOfBulkRoles?.status === 200) {
          if (type === 'activate') {
            setSelectedActivatedRoles([]);
            setSelectedDeactivatedRoles(selectedActivatedRoles);
          } else {
            setSelectedDeactivatedRoles([]);
            setSelectedActivatedRoles(selectedDeactivatedRoles);
          }
          refetch?.();
          setIsSuccessful(true);
          getSelectedRoles(selectedData);
          return;
        }
        Toast.error(res?.data?.modifyStatusOfBulkRoles?.message || 'Operation failed');
      } catch (e) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };

  const modalDetails = () => {
    switch (isSelectLoader) {
    case 'deactivate':
      return {
        title: isSuccessful ? 'Role Deactivated!' : `Are you sure you want to deactivate ${selectedActivatedRoles?.length === 1 ? 'this role' : `these ${selectedActivatedRoles?.length} roles`}`,
        subTitle: isSuccessful ? `${updateRoleNames} has been deactivated successfully.` : 'By clicking on “Deactivate Role”, all users assigned to the role will be deactivated. If you are not sure, please cancel.',
        icon: <RoundMinusIcon />,
        actionBtnName: 'Yes, deactivate',
        actionBtnClassName: Styles.wrapper__deactivateBtn,
        iconClassName: Styles.wrapper__deactivateIcon,
      };

    default:
      return {
        title: isSuccessful ? 'Role Activated!' : `Are you sure you want to activate ${selectedDeactivatedRoles?.length === 1 ? 'this role' : `these ${selectedDeactivatedRoles?.length} roles`}`,
        subTitle: isSuccessful ? `${updateRoleNames} has been activated successfully.` : 'By clicking on “Activate Role”, you are accepting to reactivate role by making it accessible in the system. If you are not sure, please cancel.',
        icon: <CircleCheckIcon />,
        actionBtnName: 'activate role',
        actionBtnClassName: Styles.wrapper__activateBtn,
        iconClassName: Styles.wrapper__activateIcon,
      };
    }
  };

  return (
    <div className={Styles.wrapper}>
      <AdminModal
        headText={modalDetails()?.title}
        subText={modalDetails()?.subTitle}
        actionBtnName={modalDetails()?.actionBtnName}
        handleModalAction={() => (isSelectLoader === 'deactivate' ? activateAndDeactivateMutipleRoles('deactivate', selectedActivatedRoles) : activateAndDeactivateMutipleRoles('activate', selectedDeactivatedRoles))}
        topIcon={<div className={modalDetails()?.iconClassName}>{modalDetails()?.icon}</div>}
        isShow
        isActionBtnDisabled={modifyMutipleRolesStatusLoading}
        isSuccess={isSuccessful}
        isTopIcon
        onClickAway={onClose}
        onClose={onClose}
        isLoading={modifyMutipleRolesStatusLoading}
        hideLogo
        cancelBtnClass={Styles.wrapper__cancelBtn}
        actionBtnClass={isSuccessful ? Styles.wrapper__okayBtn : modalDetails()?.actionBtnClassName}
      />
    </div>
  );
};

export default ActivateAndDeactivateBulkRoles;
